import { render, staticRenderFns } from "./PositionList.vue?vue&type=template&id=70f2052b&scoped=true&lang=pug&"
import script from "./PositionList.vue?vue&type=script&lang=ts&"
export * from "./PositionList.vue?vue&type=script&lang=ts&"
import style0 from "./PositionList.vue?vue&type=style&index=0&id=70f2052b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2052b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VEditDialog,VIcon,VTextField,VTooltip})
